module.exports = __webpack_public_path__ + "static/deva-a747bcc226f67e183a7d4c654a019c23.png";